import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagHR = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M50 25c0-3.058-.55-5.988-1.555-8.696L25 15.217 1.555 16.304A24.946 24.946 0 0 0 0 25c0 3.058.55 5.987 1.555 8.695L25 34.782l23.445-1.087A24.946 24.946 0 0 0 50 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M25 50c10.75 0 19.913-6.784 23.445-16.304H1.555C5.088 43.216 14.251 50 25 50Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M1.555 16.304h46.89C44.913 6.784 35.75 0 25 0S5.088 6.784 1.555 16.304Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#338AF3",
  d: "M31.521 17.392h-4.348l.725-5.435 2.898-2.174 2.899 2.174v4.348l-2.174 1.087ZM18.478 17.392h4.348l-.725-5.435-2.898-2.174-2.899 2.174v4.348l2.174 1.087Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M27.899 17.392h-5.797v-5.435L25 9.783l2.899 2.174v5.435Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M16.304 16.304v11.957a8.688 8.688 0 0 0 3.497 6.966l1.521-.38 1.92 1.93a8.7 8.7 0 0 0 3.506.003l2.192-1.825 1.26.268a8.685 8.685 0 0 0 3.496-6.962V16.304H16.304Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M16.304 16.304h3.479v3.479h-3.479v-3.479ZM23.261 16.304h3.478v3.479h-3.478v-3.479ZM30.218 16.304h3.478v3.479h-3.478v-3.479Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M19.782 19.782h3.478v3.478h-3.478v-3.478ZM26.739 19.782h3.478v3.478H26.74v-3.478ZM16.304 23.26h3.479v3.479h-3.479V23.26Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M19.782 26.738h3.478v3.479h-3.478v-3.479ZM23.261 23.26h3.478v3.479h-3.478V23.26ZM30.218 23.26h3.478v3.479h-3.478V23.26ZM26.739 26.738h3.478v3.479H26.74v-3.479ZM23.261 30.216h3.478v3.478h-3.478v-3.478ZM19.783 30.217h-3.254a8.67 8.67 0 0 0 1.69 3.478h1.564v-3.478ZM30.218 33.695h1.564a8.667 8.667 0 0 0 1.69-3.478h-3.254v3.478ZM19.782 33.695v1.517a8.66 8.66 0 0 0 3.478 1.57v-3.087h-3.478ZM26.739 33.695v3.086a8.658 8.658 0 0 0 3.478-1.569v-1.517H26.74Z"
}));
FlagHR.displayName = 'FlagHR';
export default withFlagWrapper(FlagHR);
//# sourceMappingURL=index.js.map